var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive rwd-table",class:{ 'rwd-table--bordered': _vm.bordered }},[_c('div',{staticClass:"rwd-table__inner",style:(_vm.innerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }